


// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header, { Footer } from './components/HeaderNFooter';
import Home from './components/Home';
import Auth from './components/Auth';
import Dashboard from './components/Dashboard';
import PricingPage from './components/Pricing';
import Checkout, { Success, Failure } from './components/checkout';
import ProtectedRoute from './components/ProtectedRoute';
import Onboard from './components/Onboard';
import useStore from './appservices/store';
import { Pane, Spinner } from 'evergreen-ui';
import { analyticsService, AuthListener } from './appservices/AppManager';

function App() {
  return (
    <Router>
      <AuthListener />
      <DynamicLayout />
    </Router>
  );
}

const DynamicLayout = () => {
  const location = useLocation();
  const { isLoading, user, subscriptionStatus, onboardComplete } = useStore();

  // Track page views
  // useEffect(() => {
  //   analyticsService.trackEvent('Page Viewed', {
  //     page: location.pathname,
  //     timestamp: new Date().toISOString(),
  //     user: user ? user.uid : 'Guest',
  //   });
  // }, [location, user]);

  // Routes where the footer should be hidden
  const hideFooterRoutes = ['/auth', '/dashboard/onboard'];
  const shouldHideFooter = hideFooterRoutes.includes(location.pathname);

  return (
    <>
      <Header />
      {isLoading && (
        <Pane
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="fixed"
          top={0}
          left={0}
          width="100%"
          height="100%"
          background="rgba(255, 255, 255, 0.8)"
          zIndex={9999}
        >
          <Spinner size={64} />
        </Pane>
      )}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/checkout" element={<ProtectedRoute condition={subscriptionStatus !== 'active'} element={<Checkout />} />} />
        <Route path="/checkout/success" element={<ProtectedRoute condition={subscriptionStatus === 'pending'} element={<Success />} />} />
        <Route path="/checkout/failure" element={<ProtectedRoute condition={subscriptionStatus === 'pending'} element={<Failure />} />} />
        <Route path="/dashboard" element={<ProtectedRoute condition={subscriptionStatus === 'active'} element={<Dashboard />} />} />
        <Route path="/dashboard/onboard" element={<ProtectedRoute condition={!onboardComplete} element={<Onboard />} />} />
      </Routes>

      {!shouldHideFooter && <Footer />}
    </>
  );
};

export default App;
